/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { listUnitOfMeasurements_1 } from '../fn/unit-of-measurement/list-unit-of-measurements-1';
import { ListUnitOfMeasurements_1$Params } from '../fn/unit-of-measurement/list-unit-of-measurements-1';

@Injectable({ providedIn: 'root' })
export class UnitOfMeasurementService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `listUnitOfMeasurements_1()` */
  static readonly ListUnitOfMeasurements_1Path = '/api/gmn/UnitOfMeasurement/listUnitOfMeasurements';

  /**
   * List orders for waiter.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `listUnitOfMeasurements_1()` instead.
   *
   * This method doesn't expect any request body.
   */
  listUnitOfMeasurements_1$Response(params?: ListUnitOfMeasurements_1$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return listUnitOfMeasurements_1(this.http, this.rootUrl, params, context);
  }

  /**
   * List orders for waiter.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `listUnitOfMeasurements_1$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  listUnitOfMeasurements_1(params?: ListUnitOfMeasurements_1$Params, context?: HttpContext): Observable<void> {
    return this.listUnitOfMeasurements_1$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

}
